import { Box, Divider, Typography } from '@mui/material';
import { Link } from 'react-router';
import { ReportImage } from '~/components/ReportImage';
import { useSuggestions } from '~/hooks/useSuggestions';
import { TECHS } from './data';
import {
  getTechBadgeSx,
  getTechCheckmarkSx,
  techColumnCountSx,
  techColumnDividerSx,
  techColumnFooterRowSx,
  techColumnListSx,
  techColumnOuterSx,
  techColumnTechImageSx,
  techColumnTechNameTypographySx,
  techColumnTechsDetectedLabelSx,
} from './ScannerAnimation.styles';
import { ColumnLabel } from './SharedComponents';
import type { TechColumnProps } from './types';

export function TechColumn({ techsForSite, detectedTechs }: TechColumnProps) {
  const suggestions = useSuggestions();
  return (
    <Box sx={techColumnOuterSx}>
      <ColumnLabel>Technologies Found</ColumnLabel>

      <Box sx={techColumnListSx}>
        {techsForSite.map((key) => {
          const tech = TECHS[key];
          const visible = detectedTechs.has(key);
          return (
            <Box
              key={key}
              component={Link}
              to={`/technology-reports/_/${tech.uuid}`}
              sx={getTechBadgeSx(visible)}>
              <ReportImage
                uuid={tech.uuid}
                width={26}
                height={26}
                sx={techColumnTechImageSx}
              />
              <Typography sx={techColumnTechNameTypographySx}>
                {tech.name}
              </Typography>
              <Typography sx={getTechCheckmarkSx(visible)}>✓</Typography>
            </Box>
          );
        })}
      </Box>

      <Divider sx={techColumnDividerSx} />
      <Box sx={techColumnFooterRowSx}>
        <Box>
          <Typography sx={techColumnCountSx}>
            {suggestions.length.toLocaleString()}
          </Typography>
          <Typography sx={techColumnTechsDetectedLabelSx}>
            technologies indexed
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
